import { LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Attente pleine page — utilisée pendant la restauration de session, avant
 * que l'app sache si l'utilisateur est connecté.
 *
 * `role="status"` + libellé traduit : un lecteur d'écran annonce l'attente au
 * lieu de laisser croire que la page est vide.
 */
export function FullPageSpinner() {
  const { t } = useTranslation('common');

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh items-center justify-center"
    >
      <LoaderCircle aria-hidden className="size-7 animate-spin text-fg-muted" />
      <span className="sr-only">{t('state.loading')}</span>
    </div>
  );
}
